import React from 'react';

/**
 * マウス位置付近に表示する固定配置ツールチップ。
 * label と body を2段表示する（label のみの場合は1段）。
 */
export function HoverTooltip({ show, x, y, label, body }) {
  if (!show) return null;

  return (
    <div
      className="fixed z-50 px-3 py-2 bg-slate-900 text-white text-sm rounded shadow-lg pointer-events-none"
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: 'translate(-50%, -100%)',
        maxWidth: '400px',
        wordBreak: 'break-word',
      }}
      role="tooltip"
    >
      {label && <div className="font-semibold mb-0.5">{label}</div>}
      {body != null && body !== '' && <div className="whitespace-pre-wrap">{body}</div>}
      <div
        className="absolute top-full left-1/2 transform -translate-x-1/2"
        style={{
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '6px solid rgb(15 23 42)',
        }}
      />
    </div>
  );
}
